module.exports = __webpack_public_path__ + "media/fonts/Gotham_Rounded_Book-d31d488d.otf";